import React, { useMemo, useState } from 'react';
import MixPanel from 'mixpanel-browser';
import c from '../../Components/AuthLayout/authContent.module.less';
import AppConfig from '../../Config/AppConfig';

const LoginWithSSOPage = () => {
  const [email, setEmail] = useState('');

  const searchParams = new URLSearchParams(window.location.search);

  const nextString = searchParams.get('next');
  if (nextString) {
    searchParams.delete('next');
  }

  const buildLink = (emailValue) => {
    const params = new URLSearchParams();
    params.set('email', emailValue);
    if (nextString) {
      params.set('next', nextString);
    }
    for (const [key, value] of searchParams.entries()) {
      params.set(key, value);
    }
    return `/${AppConfig.ACCOUNTS_PREFIX}oidc/authenticate/?${params.toString()}`;
  };

  const link = useMemo(() => buildLink(email), [email, nextString, searchParams]);

  const handleLoginClick = (e) => {
    // Fall back to the live input value so password-manager autofill (which can skip
    // React's onChange) is still picked up; the href is built from React state.
    const liveEmail = email || document.getElementById('id_email')?.value || '';
    try {
      MixPanel.track('SSO Login Attempt', {
        email: liveEmail,
        has_next_param: !!nextString,
      });
    } catch (err) {
      console.error(err);
    }
    if (!liveEmail) {
      e.preventDefault();
      return;
    }
    if (liveEmail !== email) {
      e.preventDefault();
      window.location.href = buildLink(liveEmail);
    }
  };

  return (
    <>
      <h1 className={c.title}>Organization login</h1>
      <p className={c.text}>Enter your work email to continue with single sign-on.</p>
      <form>
        <div className={c.field}>
          <label className={c.label} htmlFor="id_email">
            Work email
          </label>
          <input
            className={c.input}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            id="id_email"
            name="email"
            placeholder="you@company.com"
            autoComplete="email"
            type="text"
          />
        </div>

        <a className={c.btnPrimary} href={link} type="submit" onClick={handleLoginClick}>
          Continue
        </a>
      </form>
    </>
  );
};

export default LoginWithSSOPage;
